import React, { Component } from 'react';
import logo from './ryan-stimmler-logo.svg';
import './App.css';

 

class App extends Component {

  constructor(props){
    super(props)

    this.state = {
      githubLink:"https://github.com/rstims",
      link:"#",
      linkText:"moc.relmmitsnayr@nayr",
      bio:"Hello, I'm a full stack engineer residing in Phoenix, AZ."
    }

    this.hoverLink = this.hoverLink.bind(this)

  }

  hoverLink(){
    this.setState({
      link:'mailto:ryan@ryanstimmler.com'
    })
  }

  render() {
    return (
      <div className="App">
        <div className="Aligner">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Ryan Stimmler</h2>
          <p className="Bio">{this.state.bio}</p>
          <p className="Bio">Skills:</p>
          <ul className="Bio">
            <li>Elixir</li>
            <li>NodeJS</li>
            <li>React</li>
            <li>React Native</li>
            <li>Terraform</li>
            <li>AWS</li>
          </ul>
          <a onMouseOver={this.hoverLink} className="Contact" href={this.state.link}>{this.state.linkText}</a>
          <div className="socials">
            <a target="_BLANK" href={this.state.githubLink} title="Follow me on Github"><span className="fa fa-github"></span></a> 
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js